<span class="bg-{{ color }}"><ng-content></ng-content></span>
